import React, { useMemo } from 'react';
// import CountryTable from '../../CountriesCard/Table';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import DynamicColTable from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/components/StatsContext/DynamicColTable';
import moment from 'moment';
const CountriesCard = (props: any) => {
  const {
    tableData = [],
    playerCountryBarData = [],
    pageId,
    dateType,
    setChartType,
    entityType,
    chartSegment,
    cardStatus,
    isDropdown,
    fixedTableData,
    countryLatestDate,
    infoItem,
    chartLoading,
    setChartLoading,
    pageCfg,
    startDate = '',
    endDate = '',
    regionsCountries = [],
  } = props;

  // console.log('CountriesCard', props);

  const { formatMessage, locale } = useIntlExtend();
  const { isLoading, isError, isNoData } = cardStatus || {};
  const disableChartType = [ChartType.Line, ChartType.Pie];
  const currentDataDateText = countryLatestDate
    ? `${formatMessage({ id: 'dbi_detail_current_data_date' })}: ${countryLatestDate}`
    : '';

  const countriesSharTitle = useMemo(() => {
    return locale === 'en-US'
      ? `${formatMessage({ id: `dbi_detail_countries_share` })} of ${formatMessage({
        id: 'dbi_global_view_players',
      })}`
      : `${formatMessage({ id: 'dbi_global_view_players' })}${formatMessage({
        id: `dbi_detail_countries_share`,
      })}`;
  }, [locale]);

  if (isLoading || isNoData || isError || isDropdown) {
    return (
      <CardSlotV2 className="dbi-mobileGames-card-context" title={countriesSharTitle} iconList={[]}>
        <CardStats cardStatus={cardStatus} isDropdown={isDropdown} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-countries-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={countriesSharTitle}
        rightText={currentDataDateText}
        activeTab={ChartType.Bar}
        disableChartType={disableChartType}
        getChange={(value: any) => {
          setChartLoading(true);
          setChartType(value);
        }}
      >
        <div className="trends-card-line">
          <Visualis
            chartType={ChartType.Bar}
            dateType={dateType}
            imageType={entityType}
            isNodata={isNoData}
            metric={chartSegment}
            chartLoading={chartLoading}
            setChartLoading={setChartLoading}
            topChartsType={pageId}
            titleNow={formatMessage({ id: infoItem.text })}
            tableData={playerCountryBarData}
            countryLatestDate={countryLatestDate}
            startDate={moment(startDate).format('YYYY-MM')}
            endDate={moment(endDate).format('YYYY-MM')}
          />
        </div>
        <DynamicColTable
          tableData={tableData}
          dateType={dateType}
          columnList={pageCfg?.tableMetricList}
          firstCol={pageCfg?.firstCol}
          getMetricValueOfCvm={(cvm, metricKey) =>
            pageCfg?.getMetricValueOfCvm?.(cvm, metricKey, 'name')
          }
          pageSizeOptions={pageCfg?.pageSizeOptions}
          defaultPageSize={pageCfg?.defaultPageSize}
          tableSortMetricProperty={'name'}
          tableSortGrowthProperty={pageCfg?.tableSortGrowthProperty}
          fixedTableData={fixedTableData}
          localizedCountryName={pageCfg?.localizedCountryName}
          regionsCountries={regionsCountries}
          pageSortAttr={{
            currentSortValue: 'desc',
            currentSortMetric: chartSegment,
            currentRatioType: 0,
          }}
          entityType={entityType}
        />
      </CardSlotV2>
    </div>
  );
};

export default CountriesCard;
